import { IReparcelingsRepository } from 'modules/customer/domain/repositories';
import {
  IVectisReparceling,
  Reparceling,
} from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisReparcelingsRepository
  implements IReparcelingsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findByHash: IReparcelingsRepository['findByHash'] = async hash => {
    const reparceling = await this.httpProvider.get<IVectisReparceling>(
      `/reparcelamentoContrato/${hash}`,
    );

    return new Reparceling(reparceling);
  };

  public update: IReparcelingsRepository['update'] = async ({
    cash,
    hash,
    installments,
  }) => {
    await this.httpProvider.put(`/reparcelamentoContrato/${hash}`, {
      valorEntrada: cash,
      numeroParcelas: installments.amount,
      valorParcela: installments.value,
    });
  };
}
